// extracted by css-extract-rspack-plugin
export default {"horizontal":"sTKnc","vertical":"Gb2BA"};